import React, { Component } from 'react'
import { Button, Confirm } from 'semantic-ui-react'
import { connect } from 'react-redux'

import { loadSaleAction } from '../redux/reducers/app/actions'

class SaveSaleButton extends Component {

  state = {
    open: false,
    header: '',
    content: '',

    isEmailWarning: false,
    isEmail2Warning: false,
    isEmailSkipped: false,
  }

  show = () => this.setState({ open: true })
  handleConfirm = () => {
    this.setState({ open: false, isEmailWarning: false, isEmail2Warning: false })
  }
  handleCancel = () => {
    this.setState({ open: false, isEmailWarning: false, isEmail2Warning: false })

    if (this.state.isEmailWarning) {
      setTimeout(() => {
        this.setState({
          header:'Warning',
          content:`If this sale is for goods to be collected at a later date, the users email must be captured!`,
          open: true,
          isEmail2Warning: true,
        })
      }, 500)
    } else if (this.state.isEmail2Warning) {
      this.setState({ isEmailSkipped: true })
    }
  }

  handleClick = () => {
    const { loadSale, sale_id, customer_order_number, customer_status, total_owingCUR, email, mobile } = this.props

    if(!customer_order_number){
      this.setState({ header:'Order Ref Incomplete' })
      this.setState({ content:'Please enter the customer name in the order ref field' })
      this.setState({ open: true })
      return(false)
    }
    //alert(typeof customer_status.OK+'@'+total_owingCUR)
    if(total_owingCUR*1>0 && typeof customer_status.OK=='undefined'){
      this.setState({ header:'Customer Account Overdue' })
      this.setState({ content:'You cannot proceed with a new sale/quote until this customer account is settled.' })
      this.setState({ open: true })
      return(false)
    }
    if(!email && !this.state.isEmailSkipped){
      this.setState({
        header:'Customer Details incomplete',
        content:`Please enter the customer email address ${mobile ? '' : 'and mobile number'}`,
        open: true,
        isEmailWarning: true,
      })
      return(false)
    }
    loadSale(sale_id)
  }

  render() {
    return (
      <div>
        <Button color="blue" onClick={this.handleClick} className="ui big icon button" >Save/Pay <i aria-hidden="true" className="angle double right icon"></i></Button>
        <Confirm
          open={this.state.open}
          header={this.state.header}
          content={this.state.content}
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirm}
          cancelButton={this.state.isEmail2Warning ? 'No email required' : 'Cancel'}
          confirmButton={this.state.isEmail2Warning ? 'Capture email' : 'OK'}
          closeOnDimmerClick={false}
          closeOnEscape={false}
        />
      </div>
    )
  }
}

const mapDispatch = dispatch => ({
	loadSale: sale_id => dispatch(loadSaleAction(sale_id)),
})

export default connect(null, mapDispatch)(SaveSaleButton)
